var Truncate;
(function (Truncate) {
    const $infoList = document.querySelector('.boxed-info-list');
    if ($infoList) {
        let visibleText = 200;
        const $descriptions = $infoList.querySelectorAll('.description');
        $descriptions.forEach($description => {
            const $descriptionsText = $description.querySelector('p');
            if ($descriptionsText) {
                const descriptionLong = $descriptionsText.innerHTML.length;
                if (descriptionLong > visibleText && !$description.querySelector('.text').classList.contains('not-truncate')) {
                    $description.querySelector('.text').classList.add('truncate');
                    const $more = $description.querySelector('.expand');
                    $more.classList.add('expanded');
                    $more.addEventListener('click', () => {
                        $description.querySelector('.text').classList.toggle('truncate');
                        $more.innerHTML = $more.innerHTML == 'Leggi ancora' ? $more.innerHTML = 'Leggi meno' : $more.innerHTML = 'Leggi ancora';
                    });
                }
            }
        });
    }
})(Truncate || (Truncate = {}));
